module.exports = __webpack_public_path__ + "img/questionMark.4031d563.png";